import moment from "moment";
import "moment/locale/id";

export const convertEmployeeList = (data) => {
  let converted = [];

  if (!data) return [];

  data.forEach((item, index) => {
    converted.push({
      key: index + 1,
      id: item.id,
      name: `${item.first_name} ${item.last_name}`,
      phone: `${item.phone}`,
      email: item.email,
      outlet: item.outlet.name,
      jabatan: item.jabatan.name,
      lastLogin: "",
      item: item,
      joinDate: moment(item.joined_at).format("DD MMMM YYYY"),
    });
  });
  return converted;
};
